


















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {

  @Prop({
    default: () => [18.66667, 25.3333, 54.00]
  })
  ratios: number[]

  @Prop({
    default: () => ['Check Item', 'Condition', 'Disposition']
  })
  headers: string[]

  columnStyle(index: number) {
    if (this.ratios.length > 0) {
      return {
        width: `${this.ratios[index]}%`
      }
    }
    return {}
  }
}
